import { useState, useEffect, useRef } from 'react';
import styles from './index.module.less';
import { ifHaveView, ifOutView } from '@/utils';

let timeOut1 = null;
let timeOut2 = null;
let timeOut3 = null;

const LastPage = ({ describeText, id }) => {
  const lastPageEleStart = useRef(null);
  const lastPageEleEnd = useRef(null);
  const lastPageScrollEvent = useRef(null);

  const [lastPageAnima, setLastPageAnima] = useState(false);

  const [firstStartInAnima, setFirstStartInAnima] = useState(false);
  const [secondStartInAnima, setSecondStartInAnima] = useState(false);
  const [secondTextAnima, setSecondTextAnima] = useState(false);
  const [thirdTextAnima, setThirdTextAnima] = useState(false);

  // 最有一页的动画
  useEffect(() => {
    window.removeEventListener('scroll', lastPageScrollEvent.current);
    if (lastPageAnima) {
      lastPageScrollEvent.current = () => {
        if (ifOutView(lastPageEleStart.current)) {
          clearTimeout(timeOut1);
          clearTimeout(timeOut2);
          clearTimeout(timeOut3);

          setFirstStartInAnima(false);
          setSecondTextAnima(false);
          setSecondStartInAnima(false);
          setThirdTextAnima(false);

          setLastPageAnima(false);
        }
      };
    } else {
      lastPageScrollEvent.current = () => {
        if (ifHaveView(lastPageEleEnd.current)) {
          clearTimeout(timeOut1);
          clearTimeout(timeOut2);
          clearTimeout(timeOut3);
          // 最后一页动画时序
          setFirstStartInAnima(true);
          timeOut1 = setTimeout(() => {
            setSecondTextAnima(true);
          }, 450);
          timeOut2 = setTimeout(() => {
            setSecondStartInAnima(true);
            timeOut3 = setTimeout(() => {
              setThirdTextAnima(true);
            }, 450);
          }, 1000);
          setLastPageAnima(true);
        }
      };
    }
    window.addEventListener('scroll', lastPageScrollEvent.current);
    return () => {
      window.removeEventListener('scroll', lastPageScrollEvent.current);
    };
  }, [lastPageAnima]);

  return (
    <div className={`${styles.block} ${styles['last-block']}`} id={id}>
      <div ref={lastPageEleStart}></div>
      {describeText.map((v, i) => (
        <div
          key={v}
          style={i === 0 ? { margin: 0 } : undefined}
          className={`${styles.content} 
    ${firstStartInAnima && i === 0 ? styles.textTransMoveUp : ''}
    ${secondStartInAnima && i === 1 ? styles.textTransMoveUp : ''}
    `}
        >
          {i === 1 && <div ref={lastPageEleEnd}></div>}
          {v.split('$').map((text, index) => (
            <div
              key={text}
              dangerouslySetInnerHTML={{
                __html: text,
              }}
              className={`${styles.text} 
        ${i === 0 && index === 0 && firstStartInAnima ? styles.textOpacity : ''} 
        ${i === 0 && index === 1 ? styles.offset : ''} 
        ${i === 0 && index > 0 && secondTextAnima ? styles['text-second'] : ''}
        ${i === 1 && index === 0 && secondStartInAnima ? styles.textOpacity : ''} 
        ${i === 1 && index > 0 && thirdTextAnima ? styles['text-second'] : ''}`}
            ></div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default LastPage;
